import { useState } from 'react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function Apply() {
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      const fileContent = await toBase64(file);

      const response = await fetch(`${API_URL}/api/apply`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          fileName: file.name,
          fileContent,
          fileType: file.type,
        }),
      });

      if (!response.ok) throw new Error('Error al enviar');
      setSubmitted(true);
    } catch (err) {
      setError('Hubo un error al enviar tu solicitud. Intenta de nuevo.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="apply-section">
      <h2>Salario Competitivo, <br />
        ¡Aplica con nosotros!</h2>
      {submitted ? (
        <div className="apply-success">
          <p>¡Gracias, {name}! Recibimos tu solicitud. Nos pondremos en contacto pronto.</p>
          <Link className="reserve" to="/">Volver al inicio <span>←</span></Link>
        </div>
      ) : (
        <form className="apply-form" onSubmit={handleSubmit}>
          <label htmlFor="fullname">Nombre completo</label>
          <input
            id="fullname"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Tu nombre completo"
            required
          />
          <label htmlFor="resume">Currículum (PDF)</label>
          <input
            id="resume"
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(e) => setFile(e.target.files[0])}
            required
          />
          {error && <p className="apply-error">{error}</p>}
          <button type="submit" className="reserve" disabled={sending}>
            {sending ? 'Enviando...' : 'Enviar solicitud'} <span>↗</span>
          </button>
        </form>
      )}
    </section>
  );
}
